document.addEventListener('DOMContentLoaded', () => {

  /* =========================
     MENU TOGGLE & INTERACTION
  ========================== */

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-menu-toggle]');
    const openMenus = document.querySelectorAll('.menu__item.is-selected');

    // CLICK OUTSIDE — close all menus
    if (!toggle) {
      openMenus.forEach(item => {
        item.classList.remove('is-selected');

        const dropdown = item.querySelector('.header__dropdown');
        dropdown?.setAttribute('hidden', '');
        dropdown?.classList.remove('is-selected');

        item.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      return;
    }

    const menuItem = toggle.closest('.menu__item');
    const dropdown = menuItem.querySelector('.header__dropdown');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';

    // CLOSE OTHER OPEN MENUS
    openMenus.forEach(item => {
      if (item !== menuItem) {
        item.classList.remove('is-selected');

        const otherDropdown = item.querySelector('.header__dropdown');
        otherDropdown?.setAttribute('hidden', '');
        otherDropdown?.classList.remove('is-selected');

        item.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      }
    });

    // TOGGLE CURRENT MENU
    toggle.setAttribute('aria-expanded', String(!expanded));
    menuItem.classList.toggle('is-selected', !expanded);

    if (!expanded) {
      dropdown.removeAttribute('hidden');
      dropdown.classList.add('is-selected');
    } else {
      dropdown.setAttribute('hidden', '');
      dropdown.classList.remove('is-selected');
    }
  });

  // ESC KEY — close all menus
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.menu__item.is-selected').forEach(item => {
        item.classList.remove('is-selected');

        const dropdown = item.querySelector('.header__dropdown');
        dropdown?.setAttribute('hidden', '');
        dropdown?.classList.remove('is-selected');

        item.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    }
  });


  /* =========================
     EXTERNAL & CONTACT LINKS
  ========================== */

  const excludedLinks = [
    'https://www.facebook.com/sparitual',
    'https://twitter.com/sparitual',
    'https://instagram.com/sparitualist'
  ];

  const isExternalLink = (url) => {
    try {
      const linkHost = new URL(url).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  };

  const enhanceExternalLinks = () => {
    document.querySelectorAll('a').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isExternalLink(href) || excludedLinks.includes(href)) return;

      link.setAttribute('target', '_blank');

      const linkText = link.textContent.trim();
      link.setAttribute(
        'aria-label',
        `${linkText}, This link will open in a new tab`
      );

      const img = link.querySelector('img, svg');
      if (img) {
        const altText = img.getAttribute('alt') || '';
        img.setAttribute(
          'alt',
          altText
            ? `${altText}, This link will open in a new tab`
            : 'This link will open in a new tab'
        );
      }
    });
  };

  const enhanceContactLinks = () => {
    document
      .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
      .forEach(link => {
        const href = link.getAttribute('href');
        const linkText = link.textContent.trim();

        if (href.startsWith('mailto:')) {
          link.setAttribute('aria-label', `Email Address: ${linkText}`);
        } else if (href.startsWith('tel:')) {
          link.setAttribute('aria-label', `Phone number: ${linkText}`);
        }
      });
  };

  enhanceExternalLinks();
  enhanceContactLinks();


  /* =========================
     ACCESSIBILITY CLEANUP
  ========================== */

  // Hide decorative elements from screen readers
  document.querySelectorAll('br, hr').forEach(el => {
    el.setAttribute('aria-hidden', 'true');
  });

  // Remove empty overlay links
  setTimeout(() => {
    document.querySelectorAll('.link-over-image').forEach(link => {
      const hasText = link.textContent.trim().length > 0;
      const hasImage = link.querySelector('img');

      if (!hasText && !hasImage) {
        link.remove();
      }
    });
  }, 1000);


  /* =========================
     IMAGE ALT TEXT VALIDATION
  ========================== */

  const irrelevantAltPatterns = [
    'untitled',
    '.jpg',
    '.jpeg',
    '.png',
    '.webp',
    'image',
    'img',
    'photo',
    'picture',
    'screenshot',
    'file',
    'pid:',
    'asset',
    'upload',
    'download',
    'placeholder',
    'default',
    'no alt',
    'alt text'
  ];

  document.querySelectorAll('img').forEach(img => {
    const alt = img.getAttribute('alt') || '';

    const isIrrelevant = irrelevantAltPatterns.some(pattern =>
      alt.toLowerCase().includes(pattern)
    );

    if (!alt.trim() || isIrrelevant) {
      img.setAttribute('alt', 'Lealfre Product');
    }
  });

});
